<template>
  <div class="route-view has-top dark">
    <div class="profile-head">
      <div class="flex-between">
        <div>
          <div class="profile">
            <div class="icon">
              <img src="/images/profile-icon.png" />
            </div>
            <div class="name">
              {{ profile.name }}
            </div>
          </div>
          <div class="time-sync">
            <div class="check-balance" @click="refreshAllSlot">
              <i class="fas fa-sync-alt"></i>
              <span>{{ $t('home.checkBalance') }}</span>
            </div>
            <div>
              {{ $t('home.updateTime') }} {{ timesync | datetimeFormat }}
            </div>
          </div>
        </div>
        <div>
          <img src="/images/logo.png" width="80" />
        </div>
      </div>
      <div class="flex-between m-t-40">
        <div class="wallet">
          <!-- <div class="amount">
            {{ wallet.amount | numberFormat }}
          </div> -->
          <div class="amount">
            {{
              $t('home.allBaht', {
                total: $options.filters.numberFormat(total)
              })
            }}
          </div>
        </div>
        <div class="layout-bonus">
          <div class="bonus">
            <label>{{ $t('home.referBonusLabel') }}</label>
            <div class="amount">
              {{ inviteAmount | decimalFormat }}
            </div>
          </div>
          <button
            class="button small is-success"
            @click="addInviteBonusToWallet"
          >
            {{ $t('home.receiveBtn') }}
          </button>
        </div>
      </div>
    </div>

    <div class="columns is-centered m-t-10 is-mobile">
      <div
        class="column is-11-mobile is-11-tablet is-11-desktop is-11-widescreen"
      >
        <div class="box-wallet">
          <div class="box-wallet-row">
            <div class="widget deposit" @click="modalDeposit">
              <div class="widget-icon">
                <i class="fas fa-money-check-alt"></i>
              </div>
              <div class="widget-title">{{ $t('home.depositTitle') }}</div>
            </div>

            <div class="vertical-row"></div>

            <div class="widget withdraw" @click="modalWithdraw(false)">
              <div class="widget-icon">
                <i class="fas fa-hand-holding-usd"></i>
              </div>
              <div class="widget-title">{{ $t('home.withdrawTitle') }}</div>
            </div>

            <div class="vertical-row"></div>

            <div v-if="isSpinActive" class="widget spinner" @click="goToSpin()">
              <div class="widget-icon">
                <i class="fas fa-crown"></i>
              </div>
              <div class="widget-title">
                หมุนวงล้อ
                <div class="coin">
                  (<i class="fas fa-coins"></i> {{ totalCoin }})
                </div>
              </div>
            </div>

            <div v-else class="widget transfer" @click="refreshAllSlot">
              <div class="widget-icon">
                <i class="fas fa-wallet"></i>
              </div>
              <div class="widget-title">{{ $t('home.refreshAllTitle') }}</div>
            </div>
          </div>

          <div class="box-wallet-row">
            <div class="widget invite" @click="modalCarouselBanner('invite')">
              <div class="widget-icon">
                <i class="fas fa-user-friends"></i>
              </div>
              <div class="widget-title">{{ $t('home.inviteTitle') }}</div>
            </div>
            <div class="vertical-row"></div>
            <div class="widget condition" @click="goToBonus()">
              <div class="widget-icon">
                <i class="fas fa-gift"></i>
              </div>
              <div class="widget-title">{{ $t('home.bonusTitle') }}</div>
            </div>
            <div class="vertical-row"></div>
            <div class="widget refund" @click="modalCarouselBanner('refund')">
              <div class="widget-icon">
                <i class="fas fa-coins"></i>
              </div>
              <div class="widget-title">{{ $t('home.refundTitle') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-title m-t-20 m-b-20" v-if="slotAccount.length > 0">
      {{ $t('home.slotAccountLabel') }} <label>(Slot)</label>
    </div>
    <carousel-3d
      ref="treeExplorer"
      :width="300"
      :height="211"
      :controls-visible="true"
      :perspective="0"
      :space="330"
      :display="3"
      :count="slotAccount.length"
      v-if="slotAccount.length > 0"
    >
      <slide v-for="(slot, index) in slotAccount" :index="index" :key="index">
        <div
          class="slot"
          v-bind:style="{ backgroundImage: `url(${slot.background})` }"
          @click="modalSlot(slot)"
        >
          <img :src="slot.logo" />
          <div class="slot-container">
            <div v-if="slot.isActive === true" class="slot-content">
              <div class="slot-amount">
                {{ slot.amount | numberFormat }}
              </div>
              <div class="slot-amount-ft">
                {{ slot.name }} :
                {{ (slot.amount * slot.ftWalletSlot) | numberFormat }}
              </div>
              <div class="slot-title">
                {{ $t('home.viewDataTitle') }}
              </div>
            </div>
            <div v-else class="slot-content">
              <div class="slot-title">
                {{ $t('home.openAccountTitle') }}
              </div>
            </div>
          </div>
        </div>
      </slide>
    </carousel-3d>

    <div class="section-title m-t-20 m-b-20" v-if="sportAccount.length > 0">
      {{ $t('home.sportAccountLabel') }} <label>(Sport + Casino)</label>
    </div>
    <carousel-3d
      ref="treeExplorer2"
      :width="300"
      :height="211"
      :controls-visible="true"
      :perspective="0"
      :space="330"
      :display="3"
      :count="sportAccount.length"
      v-if="sportAccount.length > 0"
    >
      <slide v-for="(slot, index) in sportAccount" :index="index" :key="index">
        <div
          class="slot"
          v-bind:style="{ backgroundImage: `url(${slot.background})` }"
          @click="modalSlot(slot)"
        >
          <img :src="slot.logo" />
          <div class="slot-container">
            <div v-if="slot.isActive === true" class="slot-content">
              <div class="slot-amount">
                {{ slot.amount | numberFormat }}
              </div>
              <div class="slot-amount-ft">
                {{ slot.name }} :
                {{ (slot.amount * slot.ftWalletSlot) | numberFormat }}
              </div>
              <div class="slot-title">
                {{ $t('home.viewDataTitle') }}
              </div>
            </div>
            <div v-else class="slot-content">
              <div class="slot-title">
                {{ $t('home.openAccountTitle') }}
              </div>
            </div>
          </div>
        </div>
      </slide>
    </carousel-3d>

    <div class="section-title m-t-20 m-b-20" v-if="lottoAccount.length > 0">
      {{ $t('home.lottoAccountLabel') }} <label>(Lotto)</label>
    </div>
    <carousel-3d
      ref="treeExplorer3"
      :width="300"
      :height="211"
      :controls-visible="true"
      :perspective="0"
      :space="330"
      :display="3"
      :count="lottoAccount.length"
      v-if="lottoAccount.length > 0"
    >
      <slide v-for="(slot, index) in lottoAccount" :index="index" :key="index">
        <div
          class="slot"
          v-bind:style="{ backgroundImage: `url(${slot.background})` }"
          @click="modalSlot(slot)"
        >
          <img :src="slot.logo" />
          <div class="slot-container">
            <div v-if="slot.isActive === true" class="slot-content">
              <div class="slot-amount">
                {{ slot.amount | numberFormat }}
              </div>
              <div class="slot-amount-ft">
                {{ slot.name }} :
                {{ (slot.amount * slot.ftWalletSlot) | numberFormat }}
              </div>
              <div class="slot-title">
                {{ $t('home.viewDataTitle') }}
              </div>
            </div>
            <div v-else class="slot-content">
              <div class="slot-title">
                {{ $t('home.openAccountTitle') }}
              </div>
            </div>
          </div>
        </div>
      </slide>
    </carousel-3d>
    <modal-deposit
      v-if="modalDepositActive"
      :is-active="modalDepositActive"
      :profile="profile"
      :account="bankAccount"
      @closeModal="modalDeposit"
    />
    <modal-transfer
      v-if="modalTransferActive"
      :is-active="modalTransferActive"
      :wallet="wallet"
      :slots="slots"
      @closeModal="modalTransfer"
    />
    <modal-withdraw
      v-if="modalWithdrawActive"
      :is-active="modalWithdrawActive"
      :wallet="wallet"
      :slots="slots"
      @closeModal="modalWithdraw"
    />
    <modal-invite
      v-if="modalInviteActive"
      :is-active="modalInviteActive"
      :profile="profile"
      @closeModal="modalInvite"
    />
    <modal-refund
      v-if="modalRefundActive"
      :is-active="modalRefundActive"
      :profile="profile"
      @closeModal="modalRefund"
    />
    <modal-slot-account
      v-if="modalSlotActive"
      :is-active="modalSlotActive"
      :selected-slot="selectedSlot"
      @closeModal="modalSlot"
    />
    <modal-agreement
      v-if="modalAgreementActive"
      :is-active="modalAgreementActive"
      @closeModal="modalAgreement"
    />
    <modal-carousel-img
      v-if="modalCarouselImgActive"
      :is-active="modalCarouselImgActive"
      :carousel-data="carouselData"
      :act="act"
      @closeModal="closeModalCarouselBanner"
    />
  </div>
</template>

<script>
import { isRememberAgreement } from '@/utils/agreement'
import { getLastSync, setLastSync } from '@/utils/sync'

import { Carousel3d, Slide } from 'vue-carousel-3d'

// import apiBonus from '@/api/bonus'
import apiWallet from '@/api/wallet'
import apiInvite from '@/api/invite'
import apiRefund from '@/api/refund'
import apiSpin from '@/api/spin'

import ModalDeposit from '@/views/user/components/modals/deposit/index'
import ModalTransfer from '@/views/user/components/modals/Transfer'
import ModalWithdraw from '@/views/user/components/modals/Withdraw'

import ModalInvite from '@/views/user/components/modals/Invite'
import ModalRefund from '@/views/user/components/modals/Refund'
import ModalCarouselImg from '@/views/user/components/modals/CarouselImg'
import ModalSlotAccount from '@/views/user/components/modals/SlotAccount'

import ModalAgreement from '@/views/user/components/modals/Agreement'
import i18n from '@/language'
export default {
  name: 'UserHome',
  components: {
    'carousel-3d': Carousel3d,
    slide: Slide,
    ModalDeposit,
    ModalTransfer,
    ModalWithdraw,
    ModalInvite,
    ModalRefund,
    ModalSlotAccount,
    ModalAgreement,
    ModalCarouselImg
  },
  props: {
    page: String
  },
  data() {
    return {
      timesync: '',
      slides: 6,
      selectedSlot: {},
      profile: {},
      bankAccount: {},
      wallet: {},
      slots: [],
      slotAccount: [],
      sportAccount: [],
      lottoAccount: [],
      total: 0,
      totalCoin: 0,
      inviteAmount: 0,
      inviteSuccess: 0,
      inviteFail: 0,
      modalDepositActive: false,
      modalTransferActive: false,
      modalWithdrawActive: false,
      modalInviteActive: false,
      modalRefundActive: false,
      modalSlotActive: false,
      modalAgreementActive: false,
      modalCarouselImgActive: false,
      carouselData: {},
      act: '',
      isSpinActive: false
    }
  },
  created() {
    this.timesync = getLastSync()

    this.$emit('childinit', this.page)
    // this.getUserWallet()
    this.refreshAllSlot()
    this.checkSpinActive()
  },
  mounted() {
    if (!isRememberAgreement()) {
      setTimeout(() => {
        this.modalAgreementActive = true
      }, 1500)
    }
  },
  updated: function() {
    if (this.$refs.treeExplorer)
      this.$refs.treeExplorer.goSlide(this.$refs.treeExplorer.currentIndex)

    if (this.$refs.treeExplorer2)
      this.$refs.treeExplorer2.goSlide(this.$refs.treeExplorer2.currentIndex)

    if (this.$refs.treeExplorer3)
      this.$refs.treeExplorer3.goSlide(this.$refs.treeExplorer3.currentIndex)
  },
  methods: {
    async getUserWallet(showLoading) {
      let loading

      if (!showLoading) loading = this.$loading.show()

      // setTimeout(async () => {
      try {
        const data = await apiWallet.getUserWallet()

        this.profile = data.profile
        this.bankAccount = data.bankAccount
        this.wallet = data.wallet
        this.inviteAmount = data.invite.amount
        this.inviteSuccess = data.invite.success
        this.inviteFail = data.invite.fail
        this.total = this.wallet.amount
        this.totalCoin = this.profile.coin
        this.slots = data.slots

        this.slotAccount = []
        this.sportAccount = []
        this.lottoAccount = []
        data.slots.forEach(slot => {
          if (slot.category === 'slot') {
            this.slotAccount.push(slot)
          } else if (slot.category === 'sport') {
            this.sportAccount.push(slot)
          } else if (slot.category === 'lotto') {
            this.lottoAccount.push(slot)
          }
          this.total += slot.amount
        })
        // await this.checkMinimumBonus()
      } catch (error) {
        console.log(error)
      } finally {
        // this.timesync = new Date()
        if (!showLoading) loading.hide()
      }
      // }, 200)
    },
    async refreshAllSlot() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          await apiWallet.refreshAllSlot()

          // await this.checkMinimumBonus()
        } catch (error) {
          console.log(error)
        } finally {
          setLastSync()
          this.timesync = getLastSync()
          await this.getUserWallet(true)

          loading.hide()
        }
      }, 200)
    },
    // async checkMinimumBonus() {
    //   const result = await apiBonus.checkMinimum()

    //   if (result === true) {
    //     this.$buefy.dialog.confirm({
    //       title: 'ยกเลิกเงื่อนไขโบนัส',
    //       message: 'คุณมียอดเงินรวมต่ำกว่าเงื่อนไข ต้องการยกเลิกโบนัสหรือไม่',
    //       confirmText: 'ต้องการ',
    //       cancelText: 'ไม่ต้องการ',
    //       type: 'is-danger',
    //       hasIcon: true,
    //       onConfirm: async () => {
    //         const data = await apiBonus.clearBonus()
    //         this.$buefy.toast.open(data.message)
    //       }
    //     })
    //   }
    // },
    async addInviteBonusToWallet() {
      this.$buefy.dialog.confirm({
        title: i18n.t('home.receivedInviteBonusMsg'),
        message: `*** ${i18n.t('home.condition1Msg')} ***${
          this.inviteSuccess > 0
            ? `<br><br>${i18n.t('home.condition2Msg')} <b>${
                this.inviteSuccess
              }%</b> ${i18n.t('home.condition3Msg')}<br><br>` +
              `*** ${i18n.t('home.condition4Msg')} <b>${this.inviteFail}%</b>
            ${i18n.t('home.condition5Msg')}
            <span class="has-text-danger"><b>${i18n.t(
              'home.condition6Msg'
            )}</b></span> ***</div><br>`
            : ''
        }`,
        confirmText: i18n.t('home.confirmMsg'),
        cancelText: i18n.t('home.cancelMsg'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            await apiInvite.receivedInviteBonus()
            this.$buefy.toast.open({
              message: i18n.t('home.successMsg'),
              type: 'is-success'
            })

            this.getUserWallet()
          } catch (error) {
            this.$buefy.toast.open({
              message: error,
              type: 'is-danger'
            })
          }
        }
      })
    },
    async checkSpinActive() {
      const result = await apiSpin.isActive()
      this.isSpinActive = result.isActive
    },
    modalDeposit() {
      this.modalDepositActive = !this.modalDepositActive
      this.disabledBodyScroll(this.modalDepositActive)
    },
    modalTransfer(isSaved) {
      this.modalTransferActive = !this.modalTransferActive
      this.disabledBodyScroll(this.modalTransferActive)

      if (isSaved === true) {
        this.getUserWallet()
      }
    },
    modalWithdraw(isSaved) {
      this.modalWithdrawActive = !this.modalWithdrawActive
      this.disabledBodyScroll(this.modalWithdrawActive)

      if (isSaved === true) {
        this.getUserWallet()
      }
    },
    modalInvite() {
      this.modalInviteActive = !this.modalInviteActive
      this.disabledBodyScroll(this.modalInviteActive)
    },
    async modalCarouselBanner(act) {
      this.act = act
      let loading = this.$loading.show()
      if (act === 'invite') {
        const inv = await apiInvite.getInviteBanner()
        loading.hide()
        if (inv.banners.length !== 0) {
          this.carouselData = inv.banners
          this.modalCarouselImgActive = !this.modalCarouselImgActive
          this.disabledBodyScroll(this.modalCarouselImgActive)
        } else {
          this.modalInvite()
        }
      } else if (act === 'refund') {
        const refund = await apiRefund.getRefundBanner()
        loading.hide()
        if (refund.banners.length !== 0) {
          this.carouselData = refund.banners
          this.modalCarouselImgActive = !this.modalCarouselImgActive
          this.disabledBodyScroll(this.modalCarouselImgActive)
        } else {
          this.modalRefund()
        }
      }
    },
    closeModalCarouselBanner(act) {
      this.modalCarouselImgActive = !this.modalCarouselImgActive
      if (act === 'invite') {
        this.modalInvite()
      } else if (act === 'refund') {
        this.modalRefund()
      }
    },
    modalRefund(isSaved) {
      this.modalRefundActive = !this.modalRefundActive
      this.disabledBodyScroll(this.modalRefundActive)

      if (isSaved === true) {
        this.getUserWallet()
      }
    },
    modalSlot(slot) {
      this.modalSlotActive = !this.modalSlotActive
      this.disabledBodyScroll(this.modalSlotActive)

      if (slot) this.selectedSlot = slot
      else this.selectedSlot = {}
    },
    modalAgreement() {
      this.modalAgreementActive = !this.modalAgreementActive
      this.disabledBodyScroll(this.modalAgreementActive)
    },
    disabledBodyScroll(isModalShow) {
      if (isModalShow) document.documentElement.style.overflow = 'hidden'
      else document.documentElement.style.overflow = 'auto'
    },
    goToBonus() {
      this.$router.push('bonus')
    },
    goToSpin() {
      this.$router.push('spin')
    }
  }
}
</script>

<style scoped lang="scss">
.time-sync {
  // display: flex;
  margin-top: 10px;
  font-size: 12px;

  .check-balance {
    font-size: 20px;
    // margin-left: 10px;
    font-weight: bold;

    span {
      margin-left: 5px;
      text-decoration: underline;
    }

    &:hover {
      cursor: pointer;
    }
  }
  // i {
  //
  //   font-size: 22px;

  // }
}

.card {
  .title {
    color: $dark-invert;
  }
  .detail {
    font-size: 14px;
    margin-left: 15px;
  }
}

.profile-head {
  background-image: url('/images/profile.png');
  // background-size: 100% 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 10px 10px;
  // text-shadow: 1px 1px 2px #000;
  text-shadow: -1px -1px 0px #000, 0px -1px 0px #000, 1px -1px 0px #000,
    -1px 0px 0px #000, 1px 0px 0px #000, -1px 1px 0px #000, 0px 1px 0px #000,
    1px 1px 0px #000;
  color: #ffffff;

  img {
    width: 120px;
    height: auto;
    max-width: 100%;
  }
}
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.profile {
  display: inline-flex;
  width: auto;
  height: 30px;
  padding-right: 30px;
  border-radius: 30px;
  color: black;
  background: white;
  align-items: center;
  width: 250px;

  .icon {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    color: white;
    position: absolute;
    margin-left: -8px;

    img {
      width: 45px;
      height: 45px;
    }
  }
  .name {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 40px;
    font-size: 20px;
    text-align: center;
    width: 100%;
    text-shadow: none;
  }
}

.wallet {
  .amount {
    font-size: 23px;
    font-weight: 700;
  }
}

.layout-bonus {
  display: flex;
  align-items: flex-end;

  .bonus {
    text-align: right;
    label {
      font-size: 14px;
      text-shadow: -1px -1px 0px #000, 0px -1px 0px #000, 1px -1px 0px #000,
        -1px 0px 0px #000, 1px 0px 0px #000, -1px 1px 0px #000, 0px 1px 0px #000,
        1px 1px 0px #000;
      color: #ffffff;
    }
    .amount {
      width: 100px;
      background: white;
      border-radius: 20px;
      padding: 0 10px;
      color: black;
      text-shadow: none;
    }
  }
}

.box-wallet {
  width: 100%;
  background-color: $box-bg;
  border-radius: 15px;
  border: 1px solid $primary;

  .box-wallet-row {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
  }

  .vertical-row {
    width: 1px;
    background: $dark;
    top: 0;
    bottom: 0;
    left: 50%;
    margin: 15px 0;
  }

  .widget {
    // border: 1px solid $dark;
    border-radius: 10px;
    text-align: center;
    padding: 10px 0;
    color: $box-text;
    cursor: pointer;
    width: 100px;
    height: 100px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .widget-title {
      font-size: 18px;
      // font-weight: 700;
    }

    .widget-icon {
      font-size: 25px;
    }

    .coin {
      font-size: 14px;
    }

    &:hover {
      color: $box-text;
    }
  }
}

.carousel-3d-slide {
  border-radius: 20px;
  background-color: transparent !important;
  border-color: transparent !important;
}

/deep/ .carousel-3d-controls {
  .next,
  .prev {
    color: white;
  }
}
.slot {
  position: relative;
  // margin: 0 10px;
  background-size: 100% 100%;
  height: 100%;
  text-align: center;
  display: block;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  img {
    width: auto;
    max-width: 220px;
    height: auto;
    max-height: 100px;
    margin-top: 10px;
  }

  .slot-container {
    position: absolute;
    // background-color: rgba(0, 0, 0, 0.4);
    text-shadow: -1px -1px 0px #000, 0px -1px 0px #000, 1px -1px 0px #000,
      -1px 0px 0px #000, 1px 0px 0px #000, -1px 1px 0px #000, 0px 1px 0px #000,
      1px 1px 0px #000;
    color: #ffffff;
    bottom: 0;
    min-width: 100%;
    height: 120px;
    text-align: center;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    display: table;

    .slot-content {
      display: table-cell;
      vertical-align: middle;
      .slot-amount {
        font-weight: 700;
        font-size: 30px;
      }
      .slot-amount-ft {
        font-size: 12px;
      }
      .slot-title {
        font-size: 12px;
      }
    }
  }
}

.disabled-child {
  pointer-events: none;
  opacity: 0.3;
}

.button {
  margin-left: 10px;
  &.small {
    padding: 5px 10px !important;
    border-radius: 10px;
    height: fit-content;
  }
}
</style>
